module.exports = __webpack_public_path__ + "img/bcbc.19d0b438.svg";